export default __webpack_public_path__ + "static/media/footer.6dec8195.jpg";